import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation-2",
  "use": "navigation-2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"navigation-2\">\n<path d=\"M19,22c-0.2,0-0.3,0-0.5-0.1L12,18.2l-6.5,3.7c-0.4,0.2-0.8,0.2-1.1-0.1C4,21.5,3.9,21,4.1,20.7l7-19C11.2,1.3,11.6,1,12,1\n\ts0.8,0.3,0.9,0.7l7,19c0.1,0.4,0,0.8-0.3,1.1C19.5,21.9,19.2,22,19,22z M12,16c0.2,0,0.3,0,0.5,0.1l4.6,2.6L12,4.9L6.9,18.8l4.6-2.6\n\tC11.7,16,11.8,16,12,16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol